import { render, staticRenderFns } from "./saAsideUser.vue?vue&type=template&id=6edc78c7"
import script from "./saAsideUser.vue?vue&type=script&lang=js"
export * from "./saAsideUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports